import { IComponentOptions, IController, IPromise } from "angular";
import { IModalService } from "angular-ui-bootstrap";

import { IModalComponent } from "@gtmhub/core/routing";
import { localize } from "@gtmhub/localization";
import { UiButtonTypeLegacy } from "@webapp/ui/button/models/button.models";

export interface IWarningModalComponentBindingsResolve {
  modalImage: string;
  modalTitle: string;
  modalText: string;
  confirmBtnType?: UiButtonTypeLegacy;
  confirmText: string;
  dismissText: string;
  modalClass?: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface WarningModalCtrl extends IModalComponent<IWarningModalComponentBindingsResolve> {}

export class WarningModalCtrl implements IController {
  imgSrc: string;
  title: string;
  text: string;
  confirmBtnType: UiButtonTypeLegacy;
  confirmBtnText: string;
  dismissBtnText: string;
  $onInit(): void {
    this.imgSrc = this.resolve.modalImage;
    this.title = localize(this.resolve.modalTitle);
    this.text = localize(this.resolve.modalText);
    this.confirmBtnType = this.resolve.confirmBtnType || "primary";
    this.confirmBtnText = localize(this.resolve.confirmText);
    this.dismissBtnText = localize(this.resolve.dismissText);
  }
}

export class WarningModalService {
  static $inject = ["$uibModal"];
  constructor(private $uibModal: IModalService) {}
  warningModal(args: IWarningModalComponentBindingsResolve): IPromise<unknown> {
    return this.$uibModal.open({
      component: "warningModal",
      resolve: {
        modalImage: () => args.modalImage,
        modalTitle: () => args.modalTitle,
        modalText: () => args.modalText,
        confirmBtnType: () => args.confirmBtnType,
        confirmText: () => args.confirmText,
        dismissText: () => args.dismissText,
      },
      windowClass: `medium-small p-48px ${args.modalClass || ""}`,
    }).result;
  }
}

export const WarningModalComponent: IComponentOptions = {
  controller: WarningModalCtrl,
  templateUrl: require("./warning-modal.html"),
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
};
